var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"logo"},[(_vm.showTitle)?_c('h1',[_c('img',{staticStyle:{"margin-right":"10px"},attrs:{"src":require("@/assets/logo.png"),"alt":"","srcset":""}}),(_vm.opened)?_c('span',[_vm._v(_vm._s(_vm.title))]):_vm._e()]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }